import { Components } from '@mui/material/styles';
import checkIcon from '@assets/icons/check.svg';

const muiMenuStyles: Components = {
  MuiMenu: {
    styleOverrides: {
      paper: {
        marginTop: '4px',
        border: '1px solid var(--gray-6)',
        padding: '10px 0',
        minWidth: '250px',
        boxShadow: '0.2px 2px 7px 0px rgba(70, 96, 135, 0.25)',
        transition: 'box-shadow 0.3s ease-in-out',
        '@media (max-width: 1715px)': {
          padding: '5px 0'
        }
      }
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'var(--white) !important',
        gap: 8,
        padding: '8px 16px 8px 20px',
        borderBottom: '1px solid #E0E0E0',
        fontSize: '16px',
        lineHeight: 'normal',
        position: 'relative',
        '@media (max-width: 1715px)': {
          fontSize: '13px !important',
          padding: '6px 12px 6px 16px'
        },
        '&:last-child': {
          borderBottom: 'none'
        },
        '&:hover': {
          color: 'var(--primary) !important',
          backgroundColor: 'var(--gray-11) !important',
          '& svg path, rect, & .icon': {
            stroke: 'var(--primary) !important'
          }
        },
        '&.Mui-selected': {
          '&::after': {
            content: '""',
            position: 'absolute',
            right: '16px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '16px',
            height: '16px',
            maskImage: `url("${checkIcon}")`,
            WebkitMaskImage: `url("${checkIcon}")`,
            maskRepeat: 'no-repeat',
            WebkitMaskRepeat: 'no-repeat',
            maskSize: 'contain',
            WebkitMaskSize: 'contain',
            backgroundColor: 'var(--primary)',
            '@media (max-width:1715px)': {
              width: '13px',
              height: '13px'
            }
          }
        },
        '.MuiTouchRipple-root': {
          display: 'none'
        }
      }
    }
  }
};

export default muiMenuStyles;
